import React, { useContext, useEffect, useState } from 'react';
import { Form, Col, Button, Modal } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import axios from 'axios';
import ImagesComp from './ImagesComp';
import MonthsJSON from '../../json/months.json';
import { PasaporteImgComp } from './PasaporteImgComp';

import RenapoContext from '../../context/RenapoContext';
import ProspectosContext from '../../context/ProspectosContext';
import AlertImageContext from '../../context/AlertImageContext';
import ViewContext from '../../context/ViewContext';
import AlldataComp from '../../context/AlldataComp';
import LoadingTailwindContext from '../../context/LoadingTailwindContext'
import LoadingTailwindComp from '../Shared/LoadingTailwindComp';
import { Setting } from '../../config';
import '../../Styles/DatosPersonales.css'

import ineFront from '../../Assets/Img/Register/CREDENCIALFRONT.png'
import ineBack from '../../Assets/Img/Register/CREDENCIALBACK.png'

const ServerRoute = Setting.API_URL;

function DatosPersonales() {

    async function Axios_ValidateToken(Token, Curp, Date) {
        let resp = axios.get(ServerRoute + "Service/ValidateToken",
            { params: { Token: Token, Curp: Curp, date: Date } },
            {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'origin': 'x-requested-with',
                    'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
                    'Content-Type': 'application/json',
                }
            })
        return resp;
    }
    async function Axios_Curp(Curp) {
        let resp = axios.get("https://webfullerette.fuller.com.mx/Service/DataByCurp",
            { params: { Curp: Curp } })
        return resp;
    }
    async function Axios_Coordinadora(data) {
        let resp = axios.get(ServerRoute + "Service/Coordinadora",
            { params: { Division: data.Division, Distrito: data.Distrito, Zona: data.Zona } },
            {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'origin': 'x-requested-with',
                    'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
                    'Content-Type': 'application/json',
                }
            })

        return resp;
    }
    async function Axios_Days(Year, Month) {
        let resp = axios.get(ServerRoute + "Service/GetDays",
            { params: { year: Year, month: Month } })
        return resp;
    }
    async function Axios_Gerente(data) {
        let resp = axios.get(ServerRoute + "Service/Gerente",
            {
                params: { Division: data.Division, Distrito: data.Distrito }
            },
            {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'origin': 'x-requested-with',
                    'Access-Control-Allow-Headers': 'POST, GET, PUT, DELETE, OPTIONS, HEAD, Authorization, Origin, Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers, Access-Control-Allow-Origin',
                    'Content-Type': 'application/json',
                }
            })
        return resp;
    }
    async function YearsSelect() {
        const date = new Date();
        let Actualyear = date.getFullYear();
        Actualyear = Actualyear - 15;
        let Startyear = Actualyear - 100;
        let obj = [];
        for (let i = Actualyear; i > Startyear; i--) {
            obj.push(i)
        }
        return obj;
    }
    async function DaysSelect(day) {
        let obj = [];
        for (var i = 1; i <= day; i++) {
            obj.push(i)
        }
        return obj;
    }
    const urlOrigen = () => {
        let urlOrigen = '';
        let location = window.location.href
        if (location.split('?')[1]) {
            let existOrigin = location.split('?')[1].includes('origen');
            if (existOrigin) {
                urlOrigen = location.split('?')[1].split('=')[1]
            }
        }
        return urlOrigen
    }
    async function ValidatePhoneNumber(phone) {
        let resp = await axios.get(ServerRoute + "Service/ValidaNumCel",
            { params: { numCel: phone } });

        let {isExists} = resp.data
        if(isExists){
            setErrorPhoneExist(true)
        }
        return isExists 
        
    }
    const { register, formState: { errors }, handleSubmit, clearErrors } = useFormContext();
    const [dataProspecto, setdatProspecto] = useContext(ProspectosContext);
    const [dataRenapo, setdataRenapo] = useContext(RenapoContext);
    const [, setAlertImageData] = useContext(AlertImageContext);
    const [, setAlldataComp] = useContext(AlldataComp);
    const [, setdataView] = useContext(ViewContext);
    const [dataLoadingTailwind, setdataLoadingTailwind] = useContext(LoadingTailwindContext);

    const [boolImageFront, setBoolImageFront] = useState(false);
    const [boolCurpmsg, setBoolCurpmsg] = useState(false);
    const [dataUrl, setDataUrl] = useState({ 'refresh': '', 'utm_source': '', 'utm_medium': '', 'utm_campaign': '' });
    const [YearsArray, setObjYears] = useState([]);
    const [MonthsArray, setObjMonths] = useState([]);
    const [Dayitem, setDayItem] = useState(dataRenapo.Day);
    const [DaysArray, setObjDays] = useState([]);
    const [documentsArray, setItems] = useState([]);
    const [, setAlertBool] = useState(false);
    const [boolImgPassport, setBoolImgPassport] = useState(false)
    const [locationURL, setlocationURL] = useState(urlOrigen())
    const [show, setShow] = useState(false);
    const [habilitarCamposCURP, sethabilitarCamposCURP] = useState(true);
    const [error500CURP, seterror500CURP] = useState(false);
    const [errorPhoneExist, setErrorPhoneExist] = useState(false);
    const [errorMail, setErrorMail] = useState(false);



    const onBlurCURP = async event => {
        let validate = null
        let curp = event.target.value;
        let RFC = curp.substr(0, 10).toUpperCase();
        curp = curp.toUpperCase();
        const re = /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;
        validate = curp.match(re);
        if (validate) {
            setBoolCurpmsg(false);
            try {
                setBoolCurpmsg(false);
                setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: true, location: false, loading: true, label: "Validando CURP, espere por favor" }))

                let resp = await Axios_Curp(curp.toUpperCase());

                setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
                if (resp.status === 200 && resp.data.code === 200) {
                    const m = curp.match(/^\w{4}(\w{2})(\w{2})(\w{2})/);
                    let year = parseInt(m[1], 10) + 1900;
                    if (year < 1920) year += 100;
                    let month = parseInt(m[2], 10);
                    let day = parseInt(m[3], 10);
                    let Renapo = resp.data.data.respuestaRENAPO.curpStatus.resultCURPS;
                    let respDays = await Axios_Days(year, month);
                    if (respDays.status === 200 && respDays.data.code === 200) {
                        setDayItem(respDays.data.data);
                    }
                    else {
                        console.log("Error", respDays);
                    }
                    clearErrors()
                    setdataRenapo(item => ({ ...item, Name: Renapo.nombres, LastnameP: Renapo.apellidoPaterno, Genere: Renapo.sexo, LastnameM: Renapo.apellidoMaterno, Year: year, Month: month, Day: day, RFC: RFC }));
                }
                else {
                    sethabilitarCamposCURP(false)
                    seterror500CURP(true)
                    setdataRenapo(item => ({ ...item, Name: "", LastnameP: "", Genere: "", LastnameM: "", Year: 0, Month: 0, Day: 0, RFC: "" }));
                }
            }
            catch (e) {
                setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))
            }
        } else {
            event.target.value = "";
            setBoolCurpmsg(true);
        }
    }

    const onChangeYear = async event => {
        setdataRenapo(item => ({ ...item, Year: event.target.value }));
    }

    const onChangeDominio = async event => {
        setdataRenapo(item => ({ ...item, Correo: '' }));
        setdataRenapo(item => ({ ...item, dominio: event.target.value }));
    }

    const onChangeMonth = async event => {
        setdataRenapo(item => ({ ...item, Month: event.target.value }));
        if (event.target.value) {
            let respDays = await Axios_Days(dataRenapo.Year, event.target.value);
            if (respDays.status === 200 && respDays.data.code === 200) {
                setDayItem(respDays.data.data);
            }
            else {
                console.log("Error", respDays);
            }
        }
    }

    const onKeyUpCorreo = async event => {
        event.target.value = event.target.value.toLowerCase();
    }

    const onSubmit = async data => {

        async function returnToken(dataRenapo) {
            let monthStr = dataRenapo.Month
            let dayStr = dataRenapo.Day
            const removeAccents = async (value) => {
                return (value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")).toUpperCase();
            }
            if (dataRenapo.Name)
                dataRenapo.Name = await removeAccents(dataRenapo.Name);
            if (dataRenapo.LastnameP)
                dataRenapo.LastnameP = await removeAccents(dataRenapo.LastnameP);
            if (dataRenapo.LastnameM)
                dataRenapo.LastnameM = await removeAccents(dataRenapo.LastnameM);
            let lastName = dataRenapo.LastnameM.trim() === '' ? ' ' : dataRenapo.LastnameM.trim()
            if (dataRenapo.lastName === 'X')
                lastName = ''
            let strToken = dataRenapo.Name.replace(/\s/g, "") + (dataRenapo.LastnameP.trim()).replace(/\s/g, "") + lastName.replace(/\s/g, "") + dayStr + monthStr + dataRenapo.Year;
            return strToken.toUpperCase();
        }

        async function returnDate(dataRenapo) {
            let month = dataRenapo.Month;
            let day = dataRenapo.Day;
            if (parseInt(month) < 10)
                month = '0' + dataRenapo.Month;
            if (parseInt(day) < 10)
                day = '0' + dataRenapo.Day;
            let date = month + '-' + day + '-' + dataRenapo.Year
            return date;
        }

        async function ValidateUserType(RespValidateToken) {
            //F -> Ya es Fullerette
            //P -> Es prospecto
            //N -> Es usuario nuevo
            let type = '';
            let data = null;
            if (RespValidateToken.status === 200) {
                if (RespValidateToken.data.code === 200) {
                    let statusToken = RespValidateToken.data.data.length === 0 ? 'N' : RespValidateToken.data.data.Estatus;
                    if (statusToken === 'N') {
                        type = 'N';
                        data = null;
                    }
                    else if (statusToken === 'F') {
                        type = 'F';
                        data = RespValidateToken.data.data;
                    }
                    else if (statusToken === 'P') {
                        type = 'P';
                        data = null;
                    }
                    return { status: true, type: type, data: data };
                }
                else {
                    return { status: false, type: type, data: data };
                }
            }
            else {
                return { status: false, type: type, data: data };
            }
        }

        async function Validatedata() {
            setBoolImageFront(false);
            setBoolImgPassport(false);

            let urlOrigen = '';
            let location = window.location.href
            if (location.split('?')[1]) {
                let existOrigin = location.split('?')[1].includes('origen');
                if (existOrigin) {
                    urlOrigen = location.split('?')[1].split('=')[1]
                }
            }

            let formData = new FormData();

            setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: true, location: false, loading: true, label: "Validando información, espere por favor" }))
            dataRenapo.Date = await returnDate(dataRenapo);
            dataRenapo.Token = await returnToken(dataRenapo);
            let respToken = await Axios_ValidateToken(dataRenapo.Token, data.CURP, dataRenapo.Date)
            let respValidateUserType = await ValidateUserType(respToken)
            setdataLoadingTailwind(item => ({ ...item, success: false, save: false, email: false, thinking: false, location: false, loading: false, label: "" }))

            if (respValidateUserType.status) {
                let correodominio = dataRenapo.Correo; //data.dominio == 'otro' ? dataRenapo.Correo : `${data.email}@${data.dominio}`;

                switch (respValidateUserType.type) {
                    case 'N':

                        // formData.append("correo", dataRenapo.Correo)
                        formData.append("correo", correodominio)
                        formData.append("Motivo", 5)
                        formData.append("celular", dataRenapo.Celular)
                        formData.append("origen", urlOrigen)
                        formData.append("refresh", dataUrl.refresh)
                        formData.append("utm_source", dataUrl.utm_source)
                        formData.append("utm_medium", dataUrl.utm_medium)
                        formData.append("utm_campaign", dataUrl.utm_campaign)
                        //Se inserta motivo "NO FINALIZÓ PROCESO-PASO 2"
                        fetch(`${ServerRoute}Service/LogCorreo`,
                            {
                                method: "post",
                                mode: 'cors',
                                body: formData
                            })
                        setdataView('LZ');
                        let ContactObj = {};
                        ContactObj.Celular = data.celular;
                        ContactObj.Correo = correodominio;
                        ContactObj.Telefono = "";
                        let PersonalInfobj = {};
                        PersonalInfobj.Curp = data.CURP;
                        PersonalInfobj.Day = data.BirthdayDay;
                        if (dataRenapo.Genere === 'H')
                            PersonalInfobj.Genere = "HOMBRE";
                        if (dataRenapo.Genere === 'M')
                            PersonalInfobj.Genere = "MUJER";
                        PersonalInfobj.LastnameM = data.LastnameM;
                        PersonalInfobj.LastnameP = data.LastnameP;
                        PersonalInfobj.Month = dataRenapo.Month;
                        PersonalInfobj.Name = data.Name;
                        PersonalInfobj.RFC = dataRenapo.RFC;
                        PersonalInfobj.Year = data.BirthdayYear;
                        PersonalInfobj.Token = dataRenapo.Token;
                        PersonalInfobj.Origen = urlOrigen

                        setAlldataComp((item) => ({ ...item, Contact: ContactObj, PersonalInfo: PersonalInfobj }))
                        break;
                    case 'F':

                        //Se inserta motivo "Fullerette"
                        // formData.append("correo", dataRenapo.Correo)
                        formData.append("correo", correodominio)
                        formData.append("Motivo", 1)
                        formData.append("celular", dataRenapo.Celular)
                        formData.append("origen", urlOrigen)
                        formData.append("refresh", dataUrl.refresh)
                        formData.append("utm_source", dataUrl.utm_source)
                        formData.append("utm_medium", dataUrl.utm_medium)
                        formData.append("utm_campaign", dataUrl.utm_campaign)
                        fetch(`${ServerRoute}Service/LogCorreo`,
                            {
                                method: "post",
                                mode: 'cors',
                                body: formData
                            })
                        let respCoordinadora = await Axios_Coordinadora(respValidateUserType.data);
                        let respGerente = await Axios_Gerente(respValidateUserType.data);
                        setAlertImageData(item => ({
                            ...item,
                            src: "https://webfullerette.fuller.com.mx/Content/img/Popup-rechazadas/FULLERETTE/Imagen_FulleretteActiva.png",
                            title: "YA ERES FULLERETTE",
                            body: "No pudimos procesar tu solicitud ya que con los datos que nos proporcionaste ya tenemos un registro y ya formas parte de la gran familia FULLER.",
                            body2: "Si tienes dudas o aclaraciones que realizar puedes ponerte en contacto con tu Coordinadora o Gerente para cualquier aclaración.",
                            bodyfotter: "",
                            bool: true,
                            scneario: "F",
                            dataFullerette: respValidateUserType.data.length === 0 ? { NumeroFullerette: "", Zona: 0 } : respValidateUserType.data,
                            dataCoordinadora: (respCoordinadora.data.code === 200 && respCoordinadora.status === 200) ? respCoordinadora.data.data : {},
                            dataGerente: (respGerente.data.code === 200 && respGerente.status === 200) ? respGerente.data.data : { Nombre: "", AGSTEL: "" }
                        }))
                        break;
                    case 'P':
                        //Se inserta motivo "Prospecto activo"
                        // formData.append("correo", dataRenapo.Correo)
                        formData.append("correo", correodominio)
                        formData.append("Motivo", 2)
                        formData.append("celular", dataRenapo.Celular)
                        formData.append("origen", urlOrigen)
                        formData.append("refresh", dataUrl.refresh)
                        formData.append("utm_source", dataUrl.utm_source)
                        formData.append("utm_medium", dataUrl.utm_medium)
                        formData.append("utm_campaign", dataUrl.utm_campaign)
                        fetch(`${ServerRoute}Service/LogCorreo`,
                            {
                                method: "post",
                                mode: 'cors',
                                body: formData
                            })
                        setAlertImageData(item => ({
                            ...item,
                            src: "https://webfullerette.fuller.com.mx/Content/img/Popup-rechazadas/ENPROCESO/Imagen_EnProceso.png",
                            title: "YA LLENASTE ESTE FOMULARIO",
                            body: "Ya tenemos tus datos, mantente atenta al correo electrónico que nos proporcionaste. Recuerda que el tiempo de respuesta del estatus de tu solicitud es de 48 horas.",
                            body2: "",
                            bodyfotter: "Verifica que nuestro correo no se haya ido a la carpeta de SPAM o de CORREO NO DESEADO",
                            bool: true,
                            scneario: "P",
                            dataFullerette: {},
                            dataCoordinadora: {},
                            dataGerente: {}
                        }))
                        break;
                    default:
                        break;
                }

                document.getElementById("root").scrollIntoView();
            }
        }

        let FileFront = dataProspecto.documentFront;
        let filePassport = dataProspecto.passport;

        if (errors.email?.type === 'required') {
            setAlertBool(true);
        } else if (dataRenapo.DocumentName === 'INE') {
            if (FileFront.file.length === 0) {
                setBoolImageFront(true);
                setdatProspecto(data => ({ ...data, errorBoolINE: true }));
            } else {
                setBoolImageFront(false);
                setdatProspecto(data => ({ ...data, errorBoolINE: false }));
                await Validatedata();
            }
        } else if (dataRenapo.DocumentName !== 'INE') {
            if (filePassport.file.length === 0) {
                setBoolImgPassport(true);
                setdatProspecto(data => ({ ...data, errorBoolPass: true }));
            } else {
                setBoolImgPassport(false);
                setdatProspecto(data => ({ ...data, errorBoolPass: false }));
                await Validatedata();
            }
        }
    }



    useEffect(() => {
        const fetchIDTypes = async () => {
            fetch(ServerRoute + "Service/GetTiposId")
                .then(response => {
                    response.json()
                        .then(
                            (result) => {
                                if (result.code === 200) {
                                    setItems(result.data);
                                }
                                else {
                                    console.log("Error", result)
                                }
                            },
                        )
                })
        }
        const fetchSelectsdata = async () => {
            const YearsJSON = await YearsSelect();
            setObjYears(YearsJSON)
            setObjMonths(MonthsJSON)
        }
        fetchSelectsdata();
        fetchIDTypes();

    }, []);

    useEffect(() => {
        const fetchArrayDays = async () => {
            let days = await DaysSelect(Dayitem);
            setObjDays(days)
        }
        fetchArrayDays();
    }, [Dayitem]);

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search)
        const refresh = searchParams.get('refresh')
        const utm_source = searchParams.get('utm_source')
        const utm_medium = searchParams.get('utm_medium')
        const utm_campaign = searchParams.get('utm_campaign')

        setDataUrl({
            refresh,
            utm_source,
            utm_medium,
            utm_campaign
        })
    }, [])

    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);
    const handleCorregir = () => {
        setShow(false)
        setTimeout(() => {
            document.getElementById("formBasicEmail").focus();
        }, 400)
    };

    return (
        <>
            {
                dataLoadingTailwind.loading ? (<LoadingTailwindComp label={dataLoadingTailwind.label} />) :
                    (

                        <Form key={1} onSubmit={handleSubmit(onSubmit)}>
                            <div className='row'>
                                <div className='col-12 mb-4 form_subtitle'>
                                    <label className="font-weight-bold form_subtitle-label">Datos personales</label> <br />
                                    <label className='form_label-oblugatorio'>Los campos marcados con <span className="span-blue">*</span> <span className="">son obligatorios</span></label>
                                </div>
                                <div className='mb-4 col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5'>
                                    <Form.Group controlId="formBasicEmail">
                                        {/* <Form.Label className="font-weight-bold">Correo electrónico <span className="span-blue">*</span></Form.Label> */}
                                        <Form.Control className="simple-field form_input_new"
                                            maxLength={150}
                                            type="email"
                                            placeholder='Correo electrónico *'
                                            name="email"
                                            onKeyUp={onKeyUpCorreo}
                                            {...register("email", {
                                                required: true,
                                                value: (dataRenapo.Correo).toLowerCase(),
                                                onChange: (e) => {
                                                    setdataRenapo(item => ({ ...item, Correo: (e.target.value).toLowerCase() }))
                                                },
                                                onBlur: (e) => {
                                                    let correo = e.target.value;
                                                    var re = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
                                                    let validado = correo.match(re);

                                                    if (validado) {
                                                        setErrorMail(false)
                                                        let regex = /^[-\w.%+]{1,64}@([A-Z0-9-]{1,63})?(mail.)(com)(.mx)?$/i
                                                        if (regex.test(correo)) {
                                                            handleShow()
                                                            let formData = new FormData();
                                                            formData.append("correo", correo)
                                                            formData.append("Motivo", 4)
                                                            formData.append("celular", dataRenapo.Celular)
                                                            formData.append("origen", locationURL)
                                                            formData.append("refresh", dataUrl.refresh)
                                                            formData.append("utm_source", dataUrl.utm_source)
                                                            formData.append("utm_medium", dataUrl.utm_medium)
                                                            formData.append("utm_campaign", dataUrl.utm_campaign)
                                                            fetch(`${ServerRoute}Service/LogCorreo`,
                                                                {
                                                                    method: "post",
                                                                    mode: 'cors',
                                                                    body: formData
                                                                })
                                                        } else {
                                                            handleShow()
                                                        }
                                                    }
                                                    else {
                                                        setErrorMail(true)
                                                        // errors
                                                        // e.target.value = '';
                                                    }
                                                },
                                                pattern: {
                                                    value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                                                },
                                            })
                                            }
                                        />
                                        {(errors?.email || errorMail) && <label className="mandatory">¡Correo necesario! Favor de ingresar un correo electrónico válido</label>}
                                    </Form.Group>
                                </div>
                                <div className='mb-4 col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                    <Form.Group>
                                        {/* <Form.Label htmlFor="celular" className="font-weight-bold">Celular  <span className="span-blue">*</span></Form.Label> */}
                                        <Form.Control className="simple-field form_input_new" type="tel"
                                            placeholder='Celular *'
                                            name="celular" {...register("celular", {
                                                required: true,
                                                value: dataRenapo.Celular,
                                                pattern: {
                                                    value: /^[+-]?\d*(?:[.,]\d*)?$/,
                                                },

                                                maxLength: 10,
                                                minLength: 10,
                                                onChange: (e) => {
                                                    setdataRenapo(item => ({ ...item, Celular: e.target.value }))
                                                },
                                                onBlur: async (e) => {
                                                    let celular = e.target.value;
                                                    celular = celular.replace(/\D/g, '');
                                                    if (celular.length < 10) {
                                                        e.target.value = '';
                                                    }
                                                    else {
                                                        let exist = await ValidatePhoneNumber(celular) 
                                                        if(!exist){
                                                            let formData = new FormData();
                                                            formData.append("correo", dataRenapo.Correo)
                                                            formData.append("Motivo", 4)
                                                            formData.append("celular", celular)
                                                            formData.append("origen", locationURL)
                                                            formData.append("refresh", dataUrl.refresh)
                                                            formData.append("utm_source", dataUrl.utm_source)
                                                            formData.append("utm_medium", dataUrl.utm_medium)
                                                            formData.append("utm_campaign", dataUrl.utm_campaign)
                                                            fetch(`${ServerRoute}Service/LogCorreo`,
                                                                {
                                                                    method: "post",
                                                                    mode: 'cors',
                                                                    body: formData
                                                                })
                                                        } 
                                                    }
                                                },
                                            })}
                                            maxLength={10} />
                                        {/* <Form.Label className="small-label font-weight-bold">10 DÍGITOS </Form.Label> */}
                                        {errors?.celular && <label className="mandatory">¡Celular necesario! Favor de ingresar un número celular válido</label>}
                                        {errorPhoneExist && <label className="mandatory">¡El celular que se ha ingresado ya existe.</label>}
                                    </Form.Group>
                                </div>
                                <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <Form.Group>
                                        {/* <Form.Label htmlFor="CURP" className="font-weight-bold">C.U.R.P  <span className="span-blue">*</span></Form.Label> */}
                                        <Form.Control
                                            className="simple-field  label-curp form_input_new"
                                            placeholder='C.U.R.P *'
                                            type="text"
                                            autoComplete="nope"
                                            maxLength={18}
                                            name="CURP" {...register("CURP", {
                                                required: true,
                                            })}
                                            onBlur={onBlurCURP}

                                        />

                                        {
                                            (errors.CURP?.type === 'required' || boolCurpmsg) && <label className="mandatory">¡Dato necesario! Favor de ingresar su C.U.R.P</label>
                                        }
                                        {
                                            error500CURP && <label className="mandatory">¡Lamentablemente hubo un error! Inténtelo más tarde.</label>
                                        }
                                        <Form.Label className="text-right">¿No lo conoces? Consúltalo
                                            <a className="font-weight-bold link-black" target="_blank" rel="noopener noreferrer" href="https://www.gob.mx/curp/" > aquí</a>
                                        </Form.Label>
                                    </Form.Group>
                                </div>
                                <div className='mb-4 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <Form.Group>
                                        {/* <Form.Label htmlFor="Name" className="font-weight-bold">Nombre(s) <span className="span-blue">*</span></Form.Label> */}
                                        <Form.Control className="simple-field form_input_new"
                                            placeholder='Nombre(s) *'
                                            type="text"
                                            value={dataRenapo.Name}
                                            disabled={habilitarCamposCURP}
                                            {...register("Name",
                                                {
                                                    required: true,
                                                    value: dataRenapo.Name,
                                                    onChange: (e) => setdataRenapo(item => ({ ...item, Name: e.target.value }))
                                                })}
                                            maxLength={150} />
                                        {errors.Name?.type === 'required' && <label className="mandatory">¡Dato necesario! Favor de ingresar su Nombre o Nombres</label>}
                                    </Form.Group>
                                </div>
                                <div className='mb-4 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <Form.Group as={Col}>
                                        {/* <Form.Label htmlFor="LastnameP" className="font-weight-bold">Apellido Paterno <span className="span-blue">*</span></Form.Label> */}
                                        <Form.Control className="simple-field form_input_new"
                                            type="text"
                                            placeholder='Apellido Paterno *'
                                            value={dataRenapo.LastnameP}
                                            disabled={habilitarCamposCURP}
                                            {...register("LastnameP",
                                                {
                                                    required: true,
                                                    value: dataRenapo.LastnameP,
                                                    onChange: (e) => setdataRenapo(item => ({ ...item, LastnameP: e.target.value }))
                                                })}
                                            maxLength={150} />
                                        {errors.LastnameP?.type === 'required' && <label className="mandatory">¡Dato necesario! Favor de ingresar su Apellido Paterno</label>}
                                    </Form.Group>
                                </div>
                                <div className='mb-4 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <Form.Group as={Col}>
                                        {/* <Form.Label htmlFor="LastnameM" className="font-weight-bold">Apellido Materno <span className="span-blue">*</span></Form.Label> */}
                                        <Form.Control className="simple-field form_input_new"
                                            type="text"
                                            placeholder='Apellido Materno *'
                                            value={dataRenapo.LastnameM}
                                            disabled={habilitarCamposCURP}
                                            {...register("LastnameM",
                                                {
                                                    required: true,
                                                    value: dataRenapo.LastnameM,
                                                    onChange: (e) => setdataRenapo(item => ({ ...item, LastnameM: e.target.value }))
                                                })}
                                            maxLength={150} />
                                        {errors.LastnameM?.type === 'required' && <label className="mandatory">¡Dato necesario! Favor de ingresar su Apellido Materno</label>}
                                    </Form.Group>
                                </div>
                                {/* <div className='mb-4 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <Form.Group>
                                        <Form.Control className="simple-field form_input_new"
                                            placeholder='Teléfono'
                                            type="tel"
                                            name="telefono" {...register("telefono", {
                                                required: false,
                                                pattern: {
                                                    value: /^[+-]?\d*(?:[.,]\d*)?$/,
                                                },
                                                onBlur: (e) => {
                                                    let telefono = e.target.value;
                                                    telefono = telefono.replace(/\D/g, '');
                                                    if (telefono.length < 10) {
                                                        e.target.value = '';
                                                    }

                                                },
                                            })}
                                            maxLength={10}
                                        />
                                        {errors?.telefono && <label className="mandatory">Favor de ingresar un número de telefeno valido</label>}
                                    </Form.Group>
                                </div> */}
                            </div>

                            <div className='row mt-5'>
                                <div className='col-12 mb-4 form_subtitle'>
                                    <label className="font-weight-bold form_subtitle-label">Fecha de Nacimiento*</label> <br />
                                </div>
                                <div className='mb-4 col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                                    <Form.Group>
                                        {/* <label className="font-weight-bold"><span className="span-blue">*</span></label> */}
                                        {/* <Form.Label htmlFor="BirthdayDay" className="font-weight-bold">Día</Form.Label> */}
                                        <Form.Select className="simple-field form_select_new"
                                            value={dataRenapo.Day}
                                            disabled={habilitarCamposCURP}
                                            {...register("BirthdayDay",
                                                {
                                                    required: true,
                                                    value: dataRenapo.Day,
                                                    onChange: (e) => setdataRenapo(item => ({ ...item, Day: e.target.value }))
                                                })
                                            }>
                                            <option>Día</option>
                                            {
                                                DaysArray.map((item) =>
                                                    <option key={item} value={item}>{item}</option>
                                                )
                                            }
                                        </Form.Select>
                                        {errors.BirthdayMonth?.type === 'required' && <label className="mandatory">¡Dato necesario! Favor de ingresar su Día de Nacimiento</label>}
                                    </Form.Group>
                                </div>
                                <div className='mb-4 col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5'>
                                    <Form.Group>
                                        {/* <label className="font-weight-bold"><span className="span-blue">*</span></label> */}
                                        {/* <Form.Label htmlFor="BirthdayMonth" className="font-weight-bold">Mes</Form.Label> */}
                                        <Form.Select className="simple-field form_select_new"
                                            value={dataRenapo.Month}
                                            disabled={habilitarCamposCURP}
                                            {...register("BirthdayMonth", {
                                                required: true,
                                                value: dataRenapo.Month,
                                            })} onChange={onChangeMonth}>
                                            <option>Mes</option>
                                            {
                                                MonthsArray.map((item) =>
                                                    <option key={item.Num} value={item.Num}>{item.Mes}</option>
                                                )
                                            }
                                        </Form.Select>
                                        {errors.BirthdayMonth?.type === 'required' && <label className="mandatory">¡Dato necesario! Favor de ingresar su Mes de Nacimiento</label>}

                                    </Form.Group>
                                </div>
                                <div className='mb-4 col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4'>
                                    <Form.Group>
                                        {/* <label className="font-weight-bold"><span className="span-blue">*</span></label> */}
                                        {/* <Form.Label htmlFor="BirthdayYear" className="font-weight-bold">Año</Form.Label> */}
                                        <Form.Select className="simple-field form_select_new"
                                            value={dataRenapo.Year}
                                            disabled={habilitarCamposCURP}
                                            {...register("BirthdayYear", {
                                                required: true,
                                                value: dataRenapo.Year,
                                            })}
                                            onChange={onChangeYear}>
                                            <option>Año</option>
                                            {
                                                YearsArray.map((item) =>
                                                    <option key={item} value={item}>{item}</option>
                                                )
                                            }
                                        </Form.Select>
                                        {errors.BirthdayYear?.type === 'required' && <label className="mandatory">¡Dato necesario! Favor de ingresar su Año de Nacimiento</label>}
                                    </Form.Group>
                                </div>
                            </div>

                            <div className='row mt-5'>
                                <div className='col-12 mb-4 form_subtitle'>
                                    <label className="font-weight-bold form_subtitle-label">Identificación Oficial*</label> <br />
                                </div>
                                <div className='mb-4 col-12 col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5'>
                                    <Form.Group>
                                        {/* <Form.Label htmlFor="Identificacion" className="font-weight-bold">Identificación Oficial <span className="span-blue">*</span></Form.Label> */}
                                        <Form.Select className="simple-field form_select_new"
                                            value={dataRenapo.IDdocumento}
                                            {...register("Identificacion", {
                                                required: true,
                                                value: dataRenapo.IDdocumento,
                                                onChange: (e) => {
                                                    const oInitialFront = {
                                                        urlBase: ineFront,
                                                        url: ineFront,
                                                        file: [],
                                                    };
                                                    const oInitialBack = {
                                                        urlBase: ineBack,
                                                        url: ineBack,
                                                        file: []
                                                    };
                                                    const initialpassport = {
                                                        urlBase: 'https://webfullerette.fuller.com.mx/Content/img/ID_Image/PASAPORTE.jpg',
                                                        url: 'https://webfullerette.fuller.com.mx/Content/img/ID_Image/PASAPORTE.jpg',
                                                        file: [],
                                                    }
                                                    if (dataRenapo.IDdocumento === 1) {
                                                        setdatProspecto(item => ({ ...item, passport: initialpassport }))
                                                    }
                                                    else {
                                                        setdatProspecto(item => ({ ...item, documentFront: oInitialFront, documentReverse: oInitialBack }))
                                                    }
                                                    const DocumentName = documentsArray.find(doc => doc.ID === parseInt(e.target.value))?.Nombre;
                                                    setdataRenapo(item => ({ ...item, IDdocumento: e.target.value, DocumentName }))
                                                }
                                            })}>
                                            {
                                                documentsArray.map((items =>
                                                    <option key={items.ID} value={items.ID}>{items.Nombre}</option>))
                                            }

                                        </Form.Select>
                                        {errors.Identificacion?.type === 'required' && <label className="mandatory">¡Dato necesario ! Favor de ingresar su identificación  </label>}
                                    </Form.Group>
                                </div>
                            </div>

                            <div className='row mt-5'>
                                {
                                    dataRenapo.DocumentName === 'INE' ?
                                        <ImagesComp bool={boolImageFront} /> :
                                        <PasaporteImgComp bool={boolImgPassport} />
                                }
                            </div>

                            <div className='row'>
                                <div className='col-12'>
                                    <div className='content_form-button'>
                                        <Form.Group className="mb-3">
                                            <Button
                                                className="form_button_new" type="submit">Siguiente
                                            </Button>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>

                            <Modal show={show} onHide={handleClose}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirma tu correo</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <div className='text-center'>
                                        <p>El correo ingresado es correcto</p>
                                        <p><strong>{dataRenapo.Correo}</strong></p>
                                    </div>
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button variant="secondary" onClick={handleCorregir}>
                                        Corregir
                                    </Button>
                                    <Button variant="primary" onClick={handleClose}>
                                        Es correcto
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            {/* 
                            <Form.Group>
                                <Form.Label htmlFor="Genere" className="font-weight-bold">Sexo <span className="span-blue">*</span></Form.Label>
                                <Form.Select className="simple-field" value={dataRenapo.Genere} disabled={habilitarCamposCURP}
                                    {...register("Genere",
                                        {
                                            required: true,
                                            value: dataRenapo.Genere,
                                            onChange: (e) => setdataRenapo(item => ({ ...item, Genere: e.target.value }))
                                        })
                                    } maxLength={10}>
                                    <option></option>
                                    <option value="H">Hombre</option>
                                    <option value="M">Mujer</option>
                                </Form.Select>
                                {errors.Genere?.type === 'required' && <label className="mandatory">¡ Dato necesario ! Favor de ingresar su sexo </label>}
                            </Form.Group> */}
                        </Form>

                    )
            }
        </>
    )
}

export default DatosPersonales;

